<div class="popup-container">
  <div *ngIf="!popupTitle" class="external-advertises_header">
    {{ '+BOOKING.ADDITIONAL_SERVICES.TITLE' | translate }}
  </div>
  <div *ngIf="popupTitle" class="dialog-header">
    <button
      mat-icon-button
      mat-dialog-close
      gtm="onClose"
      gtmAction="closeDialog"
      class="close-button"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div *ngIf="popupTitle" class="popup-title p-4">
    <p class="text-center popup-title">
      {{ popupTitle | translate }}
    </p>
  </div>
  <div
    *ngIf="isAboveMedium; else mobileView"
    [class.border]="!popupTitle"
    class="mt-4 p-5 desktop-section"
  >
    <!-- Tabs Header aligned with boxes -->
    <div class="mb-4 pb-3 desktop-header">
      <div class="grid-layout desktop-header__tabs">
        <div></div>
        <div class="py-3 vi-dark-section">
          {{ '+ADDITIONAL.SERVICE.FEATURE.VIGUIDE_PRO' | translate }}
        </div>
        <div class="py-3 bg-gradient">
          {{ '+ADDITIONAL.SERVICE.FEATURE.CONTROL_ROOM_SERVICE' | translate }}
        </div>
        <div class="py-3 vi-orange-section">
          {{ '+ADDITIONAL.SERVICE.FEATURE.COMFORT' | translate }}
        </div>
      </div>
    </div>

    <!-- Remote Section -->
    <div class="grid-container remote-section">
      <!-- Remote Text Block -->
      <div class="remote-section__list">
        <ul>
          <h2>
            {{ '+ADDITIONAL.SERVICE.FEATURE.REMOTE' | translate }}
          </h2>
          <li class="mb-1" *ngFor="let remote of remoteDescription">
            {{ remote | translate }}
          </li>
        </ul>
      </div>

      <!-- Remote Boxes (equal height, center text) -->
      <div class="vi-battleshipgrey-section remote-section__blocks">
        <div>
          {{ '+ADDITIONAL.SERVICE.FEATURE.SPECIALIST_PARTNER' | translate }}<br />
          <span>{{ '+ADDITIONAL.SERVICE.FEATURE.WITH_VIGUIDEPRO' | translate }}</span>
        </div>
      </div>
      <div class="vi-orange-section text-lg remote-section__blocks">
        <div class="vi-logo-img">
          <img src="./assets/img/viessmann-white.svg" alt="Viessmann" />
        </div>
      </div>
      <div class="vi-orange-section text-lg remote-section__blocks">
        <div class="vi-logo-img">
          <img src="./assets/img/viessmann-white.svg" alt="Viessmann" />
        </div>
      </div>
    </div>

    <!-- Divider -->
    <hr class="desktop-divider" />

    <!-- Vor-Ort Section -->
    <div class="grid-container">
      <!-- Vor-Ort Text Block -->
      <div>
        <ul>
          <h2 class="text-2xl pt-3">
            {{ '+ADDITIONAL.SERVICE.FEATURE.SUBURB' | translate }}
          </h2>
          <li class="mb-1" *ngFor="let vorort of vorOrtDescription">
            {{ vorort | translate }}
          </li>
        </ul>
      </div>

      <!-- Vor-Ort Boxes -->
      <div class="vi-battleshipgrey-section suburb-section">
        {{ '+ADDITIONAL.SERVICE.FEATURE.SPECIALIST_PARTNER' | translate }}<br />
      </div>
      <div class="vi-battleshipgrey-section suburb-section">
        {{ '+ADDITIONAL.SERVICE.FEATURE.SPECIALIST_PARTNER' | translate }}
      </div>
      <div class="vi-orange-section suburb-section">
        <div class="vi-logo-img">
          <img src="./assets/img/viessmann-white.svg" alt="Viessmann" />
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="grid-container">
      <div *ngIf="popupTitle" class="col-start-2 text-center py-6">
        <ng-container *ngIf="bookingStore.hasAccessToBooking$ | async">
          <button mat-raised-button color="primary" class="vi-black-section action-btn">
            <a
              class="no-underline btn-link text-md hover:"
              href="/booking"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ '+ADDITIONAL.SERVICE.FEATURE.BTN_BOOK_VIGUIDE_PRO' | translate }}
            </a>
          </button>
        </ng-container>
      </div>

      <div [class.col-start-3]="!popupTitle" class="text-center py-6">
        <button
          mat-raised-button
          color="primary"
          class="vi-black-section line-height-normal btn-link action-btn"
        >
          <a
            class="no-underline btn-link btn-link text-md hover:"
            href="https://partnerportal.viessmann-climatesolutions.com/de/de/support/online-anfrage-stellen/td-anfrage/buchung-leitwarten-service.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ '+ADDITIONAL.SERVICE.FEATURE.BTN_BOOK_CONTROL_ROOM_SERVICE' | translate }}
          </a>
        </button>
      </div>
      <div class="text-center py-6 text-md">
        <button mat-raised-button color="primary" class="vi-black-section action-btn">
          <a
            class="no-underline btn-link text-md hover:"
            href="https://service-configurator.viessmann-climatesolutions.com/configuration/5a18d430-1489-4c40-bb8e-6822fdf0be3d?revision=0"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ '+ADDITIONAL.SERVICE.FEATURE.TO_CONFIGURATOR' | translate }}
          </a>
        </button>
      </div>
    </div>
  </div>

  <ng-template #mobileView>
    <div class="mobile-section">
      <div [class.border]="!popupTitle" class="mobile-content mb-3">
        <div class="text-center mb-3 py-3 rounded-md vi-dark-section">
          {{ '+ADDITIONAL.SERVICE.FEATURE.VIGUIDE_PRO' | translate }}
        </div>
        <div class="expandable-section">
          <app-additional-service-expandable
            [configStyle]="configForMobile[0]"
          ></app-additional-service-expandable>
        </div>

        <div class="expandable-section">
          <app-additional-service-expandable
            [configStyle]="configForMobile[1]"
          ></app-additional-service-expandable>
        </div>
        <div *ngIf="popupTitle" class="mb-3 text-center py-6 text-md">
          <ng-container *ngIf="bookingStore.hasAccessToBooking$ | async">
            <button mat-raised-button color="primary" class="vi-black-section action-btn">
              <a
                href="/booking"
                class="no-underline btn-link text-md hover:"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ '+ADDITIONAL.SERVICE.FEATURE.BTN_BOOK_VIGUIDE_PRO' | translate }}
              </a>
            </button>
          </ng-container>
        </div>
      </div>
      <div class="mobile-content">
        <div class="bg-gradient service-header-mb">
          {{ '+ADDITIONAL.SERVICE.FEATURE.CONTROL_ROOM_SERVICE' | translate }}
        </div>
        <div class="expandable-section">
          <app-additional-service-expandable
            [configStyle]="configForMobile[2]"
          ></app-additional-service-expandable>
        </div>
        <div class="expandable-section">
          <app-additional-service-expandable
            [configStyle]="configForMobile[1]"
          ></app-additional-service-expandable>
        </div>
        <div class="mb-3 text-center py-6 text-md">
          <button mat-raised-button color="primary" class="vi-black-section action-btn">
            <a
              class="no-underline btn-link text-md hover:"
              href="https://partnerportal.viessmann-climatesolutions.com/de/de/support/online-anfrage-stellen/td-anfrage/buchung-leitwarten-service.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ '+ADDITIONAL.SERVICE.FEATURE.BTN_BOOK_CONTROL_ROOM_SERVICE' | translate }}
            </a>
          </button>
        </div>
      </div>
      <div class="mobile-content">
        <div class="expandable-section-header vi-orange-section">
          {{ '+ADDITIONAL.SERVICE.FEATURE.COMFORT' | translate }}
        </div>
        <div class="expandable-section vi-orange-section">
          <app-additional-service-expandable
            [configStyle]="configForMobile[2]"
          ></app-additional-service-expandable>
        </div>
        <div class="expandable-section vi-orange-section">
          <app-additional-service-expandable
            [configStyle]="configForMobile[3]"
          ></app-additional-service-expandable>
        </div>
        <div class="mb-3 text-center py-6 text-md">
          <button mat-raised-button color="primary" class="vi-black-section action-btn">
            <a
              class="no-underline btn-link text-md hover:"
              href="https://service-configurator.viessmann-climatesolutions.com/configuration/5a18d430-1489-4c40-bb8e-6822fdf0be3d?revision=0"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ '+ADDITIONAL.SERVICE.FEATURE.TO_CONFIGURATOR' | translate }}
            </a>
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</div>
